const Check = (policies, action) => {
  if (typeof (action) === "string") {
    action = action.split(":")
    action = {
      service: action[0],
      access: action[1],
      strict: action[2]
    }
  }
  const current = policies.filter(p => p.service === action.service);
  const denies = current.filter(p => p.actions.deny).flatMap(p => p.actions.deny.split("|"))
  const allows = current.filter(p => p.actions.allow).flatMap(p => p.actions.allow.split("|"))

  const deny = !!denies.length && (denies.includes(action.access) || denies.includes("all") || action.access === "some")
  const allow = !!allows.length && (allows.includes(action.access) || allows.includes("all") || action.access === "some")
  const strict = !!action.strict;
  return (allow && !deny) || (!strict && (allow === deny));
}

export default Check

/**
 * A D │ R
 * ────╬──
 * 0 0 │ S' => allow if not strict
 * 0 1 │ 0 ─┐
 * 1 0 │ 1  => AD'
 * 1 1 │ S' => allow if not strict
 *
 * R = AD' + S'(A^D)'
 */

/**
 * some => checks if there is at least one permission for that service
 * all => checks if there is a policy with "all" permissions
 */
